import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';

export const MapContainer = styled.div`
  width: 100%; /* Take full width of parent */
  height: 100%; /* Fill the entire parent container height */
  border: 1px solid ${fromTheme('color_border')};
  border-radius: ${fromTheme('border_radius')};
  overflow: hidden; /* Prevent internal scrolling */
  position: relative; /* For absolute positioning of child elements */

  /* The Google Maps component needs to fill the container */
  & > div:first-child {
    width: 100%;
    height: 100%;
  }

  /* Loading state styling - using :first-of-type instead of :first-child for SSR compatibility */
  & > div:first-of-type {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${fromTheme('color_background_secondary')};
    z-index: 1;
  }

  /* Improve Google Maps controls styling */
  .gm-style .gm-style-iw-c {
    padding: ${fromTheme('spacing_small')} !important;
    border-radius: ${fromTheme('border_radius')} !important;
  }

  /* Make map controls more consistent with app styling */
  .gm-style .gm-style-mtc button,
  .gm-style .gm-style-mtc div {
    border-radius: ${fromTheme('border_radius')} !important;
  }

  /* Improve zoom controls styling */
  .gm-style .gm-svpc,
  .gm-style .gmnoprint > div {
    border-radius: ${fromTheme('border_radius')} !important;
    background-color: ${fromTheme('color_background')} !important;
  }
`;
